<template>
  <section class="py-8">
    <!-- ローディング表示を追加 -->
    <div class="loading-overlay" v-if="isLoading">
      <div class="spinner-border text-danger" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    <div class="container">
      <h2 class="title page__h1 pt-32 pb-32">一般決済</h2>
      <div class="row">
        <div class="box box--center mb-24" v-if="isPaymentComplete">
          <p>一般決済が完了いたしました。<br />HOMEページお戻り下さい。</p>
        </div>
        <div v-else>
          <div
            class="box box--center mb-24"
            :style="
              selected_charge_type === 'cash' && has_receipt_data
                ? 'margin-bottom:0;padding-bottom:0;'
                : ''
            "
          >
            <p v-if="!(selected_charge_type === 'cash' && has_receipt_data)">
              決済を行って下さい。
            </p>
            <p v-else class="mb-24">
              お支払い情報を確認し、コンビニでのお支払いをお願いいたします。
            </p>
          </div>
          <div class="col-12 pb-32">
            <div>
              <div class="card-body">
                <div v-if="!has_receipt_data">
                  <CartView
                    :selected_variants="selected_variants"
                    :race_sports_year="race_sports_year"
                    :draft_orders="draft_orders"
                    :sales_data="sales_data"
                    :cart_ac_title="'お支払い内訳'"
                  />
                </div>
                <div class="container px-0">
                  <!-- 支払い方法 -->
                  <div class="mb-3">
                    <div
                      v-if="!has_receipt_data"
                      class="container mb-4 pb-4 border-bottom"
                    >
                      <div class="row">
                        <div
                          class="col"
                          v-for="type in charge_type_list"
                          :key="type"
                        >
                          <div class="d-grid">
                            <button
                              type="button"
                              :class="getClassChargeType(type.key)"
                              @click="sel_charge_type(type.key)"
                            >
                              {{ type.label }}で支払う
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="container">
                      <div
                        class="row"
                        v-show="selected_charge_type == 'creditcard'"
                      >
                        <h3 class="title02 page__h2">クレジットカード</h3>
                        <div class="col-10 offset-1 col-lg-8 offset-lg-2 mb-10">
                          <div class="row">
                            <div
                              class="col-12 col-sm-6 col-md-8 mb-10 text-center"
                            >
                              ご利用可能カードブランド
                            </div>
                            <div
                              class="col-12 col-sm-6 col-md-4 mb-10 text-center"
                            >
                              <img
                                :src="
                                  assets_url +
                                  '/base/creditcard_checkout_logo.png'
                                "
                                class="w-75"
                              />
                            </div>
                          </div>
                        </div>
                        <div class="col-10 offset-1 col-lg-8 offset-lg-2">
                          <label for="card-number">カード番号:</label>
                          <div id="card-number" class="card-form__div" />
                          <label for="expiry-month">有効期限:</label>
                          <div id="expiry-month" class="card-form__div" />
                          <label for="security-code">セキュリティコード:</label>
                          <div id="security-code" class="card-form__div" />
                          <label for="holder-name">カード名義人:</label>
                          <input
                            type="text"
                            id="holder-name"
                            v-model="holder_name"
                            class="form-control mb-2"
                            placeholder="TARO YAMADA"
                          />
                        </div>
                      </div>
                      <div class="row" v-show="selected_charge_type == 'cash'">
                        <div
                          v-if="!has_receipt_data"
                          class="col-10 offset-1 col-lg-8 offset-lg-2"
                        >
                          <h3 class="title02 page__h2">コンビニ支払い</h3>
                          <KonbiniForm
                            :on-submit="chargeCash"
                            :ini_payer="get_payer"
                          />
                        </div>
                        <div class="col-10 offset-1 col-lg-8 offset-lg-2">
                          <h5>コンビニお支払い情報</h5>
                          <div>
                            <ul v-if="has_receipt_data" class="list-group">
                              <li
                                v-for="(value, key) in receipt"
                                :key="key"
                                class="list-group-item d-flex justify-content-between"
                              >
                                <span
                                  class="fw-bold text-capitalize"
                                  v-if="key == 'konbiniCode'"
                                  >コンビニ</span
                                >
                                <span
                                  class="fw-bold text-capitalize"
                                  v-else-if="key == 'receiptNumber'"
                                  >お客様番号</span
                                >
                                <span
                                  class="fw-bold text-capitalize"
                                  v-else-if="key == 'confirmationNumber'"
                                  >確認番号</span
                                >
                                <span class="text-muted">{{ value }}</span>
                              </li>
                            </ul>
                            <h2>各社のご案内</h2>
                            <ul>
                              <li v-for="(link, index) in links" :key="index">
                                <a :href="link.href" target="_blank">{{
                                  link.text
                                }}</a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="" v-if="selected_charge_type == 'creditcard'">
                  <div class="box">
                    <h5 class="title06 page__h6">
                      クレジットカード決済について
                    </h5>
                    <p class="text-start">
                      こちらのページでクレジットカード情報を入力して決済を完了させてください。<br />
                      当サイトでの決済はセキュリティ対策として、カード情報を直接保存せずトークン化して処理しています。<br />
                      クレジットカードがご利用いただけない場合は、コンビニ決済をご利用ください。<br />
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex flex-wrap mt-32 justify-content-center column-gap-24">
        <button
          class="button03 mb-3 license__btn"
          type="button"
          @click="goBack"
        >
          <font-awesome-icon
            :icon="['fas', 'chevron-left']"
            class="button03__icon"
          />
          <span class="button03__text">戻る</span>
        </button>
        <button
          class="button04 mb-3 license__btn"
          type="button"
          @click="goCharge"
          v-if="selected_charge_type === 'creditcard' && !isPaymentComplete"
          :disabled="isLoading || charge_btn_disabled"
        >
          <span class="button04__text">
            <template v-if="isLoading">処理中...</template>
            <template v-else>支払う</template>
          </span>
          <font-awesome-icon
            :icon="['fas', 'chevron-right']"
            class="button04__icon"
          />
        </button>
      </div>
    </div>
  </section>
</template>

<script>
  // ルーターとストア関連
  import { useRouter } from 'vue-router'
  import { useStore } from 'vuex'

  // コンポーネント
  import KonbiniForm from '@/components/forms/KonbiniForm.vue'
  import CartView from '../Request/CartView.vue'

  // 設定と外部ライブラリ
  import config from '../../../const'
  import axios from 'axios'

  // 決済関連
  import { usePaymentPage } from '@ootbteam/mulpay-pinia'
  import {
    cardInputStyle,
    cvcInputStyle,
    expiryInputStyle,
  } from '@/utils/cardstyle'

  /**
   * 決済ページコンポーネント
   * クレジットカードとコンビニ決済の処理を管理する
   */
  export default {
    name: 'SalesPaymentView',
    components: {
      KonbiniForm,
      CartView,
    },

    setup() {
      const router = useRouter()
      const store = useStore()

      // MulPay SDK関連の関数を取得
      const {
        handlePaymentPageProps,
        setPaymentPayload,
        setCardPaymentPayload,
        cardPayment,
        cashPayment,
        setElements,
        setHolderName,
        clear,
      } = usePaymentPage()

      return {
        router,
        store,
        handlePaymentPageProps,
        setPaymentPayload,
        setCardPaymentPayload,
        cardPayment,
        cashPayment,
        setElements,
        setHolderName,
        clear,
      }
    },

    data: function () {
      return {
        // 販売データ関連
        data_obj: {},
        selected_variants: [],
        race_sports_year: [],
        draft_orders: [],
        sales_data: {},

        // 決済設定
        selected_charge_type: 'creditcard',
        charge_type_list: [
          { key: 'creditcard', label: 'クレジットカード' },
          { key: 'cash', label: 'コンビニ' },
        ],
        merchant_obj: {},

        // カード要素
        cardNumberElement: null,
        expiryElement: null,
        cvcElement: null,
        holder_name: '',
        cardValidation: {
          cardNumber: { complete: false, error: null },
          expiry: { complete: false, error: null },
          cvc: { complete: false, error: null },
        },

        // コンビニ関連
        has_receipt_data: false,
        receipt: {},
        links: [
          {
            code: 'SEVEN_ELEVEN',
            text: 'セブンイレブン',
            href: 'https://static.mul-pay.jp/customer-convenience-store/seveneleven/index.html',
          },
          {
            code: 'LAWSON',
            text: 'ローソンの「Loppi」を使ってお支払い（お客様番号が11桁の場合）',
            href: 'https://static.mul-pay.jp/customer-convenience-store/lawson/11.html',
          },
          {
            code: 'LAWSON',
            text: 'ローソンの「Loppi」を使ってお支払い（お客様番号が14桁の場合）',
            href: 'https://static.mul-pay.jp/customer-convenience-store/lawson/14.html',
          },
          {
            code: 'FAMILYMART',
            text: 'ファミリーマートの「マルチコピー機」を使ってお支払い（第1番号11桁の場合）',
            href: 'https://www.family.co.jp/services/application/receipt.html',
          },
          {
            code: 'FAMILYMART',
            text: 'ファミリーマートの「マルチコピー機」を使ってお支払い（第2番号12桁の場合）',
            href: 'https://www.family.co.jp/services/application/receipt.html',
          },
          {
            code: 'MINISTOP',
            text: 'ミニストップの「Loppi」を使ってお支払い（お客様番号が11桁の場合）',
            href: 'https://static.mul-pay.jp/customer-convenience-store/ministop/11.html',
          },
          {
            code: 'MINISTOP',
            text: 'ミニストップの「Loppi」を使ってお支払い（お客様番号が14桁の場合）',
            href: 'https://static.mul-pay.jp/customer-convenience-store/ministop/14.html',
          },
          {
            code: 'SEICOMART',
            text: 'セイコーマートの「POSレジ」を使ってお支払い',
            href: 'https://static.mul-pay.jp/customer-convenience-store/seicomart/',
          },
        ],

        // UI状態
        isLoading: false,
        charge_btn_disabled: false,
        assets_url: config.BASE_ASSETS_URL,
        isPaymentComplete: false,
      }
    },

    methods: {
      /**
       * 販売データを読み込む
       */
      async loadSalesData() {
        this.isLoading = true
        try {
          const salesId = this.router.currentRoute.value.query.tkn
          if (!salesId) {
            alert(
              '決済IDが指定されていません。前のページからやり直してください。'
            )
            location.href = config.BASE_APP_URL
          } else if (this.application_obj.application_check_type === '420') {
            location.href = config.BASE_APP_URL
          }

          const params = { id: salesId, stat: [1], m_id: this.$store.state.auth.userId }
          const response = await this.basicPosts_S(
            config.BASE_API_URL + '/sales/lists',
            params
          )

          if (
            response?.data?.status === 200 &&
            response.data.body?.length > 0
          ) {
            // 指定されたIDに一致するデータを検索
            const exactMatch = response.data.body.find(
              (item) => item.id === salesId
            )
            this.sales_data = exactMatch || response.data.body[0]
            // this.selected_variants = this.sales_data.selected_variants || []
            // variant.price) }}円sub_label }}sports_year
            this.selected_variants = []
            this.sales_data.sales_orders.map(sales_order => {
              this.selected_variants.push({
                price: sales_order.list_price,
                sub_label: sales_order.sub_label,
                sports_year: sales_order.sports_year,
                category: sales_order.article_cateogry,
                sports_year_add: sales_order.sports_year_add,
              })
            })
            // this.selected_variants = this.sales_data.sales_orders || []
            this.race_sports_year = this.sales_data.race_sports_year || []
            this.draft_orders = this.sales_data.draft_orders || []
            console.log('loadSalesData sales_data', this.sales_data)
          } else {
            alert(
              '販売データが見つかりませんでした。ページを再読み込みするか、前のページからやり直してください。'
            )
            this.$router.push({
              path: '/',
            })
          }
        } catch (error) {
          console.error('販売データ取得エラー:', error)
          alert('販売データの取得中にエラーが発生しました。')
        } finally {
          this.isLoading = false
        }
      },

      /**
       * 支払い方法のクラスを取得
       */
      getClassChargeType(type) {
        return {
          btn: true,
          'btn-outline-secondary': this.selected_charge_type !== type,
          'btn-warning': this.selected_charge_type === type,
        }
      },

      /**
       * 支払い方法を選択
       */
      async sel_charge_type(charge_type) {
        this.isLoading = true
        try {
          this.selected_charge_type = charge_type
          await this.loadSalesData()
          await this.loadApplicationObj()
        } catch (error) {
          console.error('支払い方法選択エラー:', error)
          alert('支払い方法の選択中にエラーが発生しました。')
        } finally {
          this.isLoading = false
        }
      },

      /**
       * 前のページに戻る
       */
      goBack() {
        location.href = config.BASE_APP_URL
      },

      /**
       * 決済処理を開始
       */
      async goCharge() {
        this.isLoading = true
        try {
          if (this.selected_charge_type === 'creditcard') {
            await this.charge_credit()
          }
        } catch (error) {
          console.error('決済エラー:', error)
          alert('お支払い処理中にエラーが発生しました。')
        } finally {
          this.isLoading = false
        }
      },
      async mp_token_mount() {
        // MpTokenに必要な情報を設定
        const mulpay = await this.handlePaymentPageProps({
          instance: axios.create({
            baseURL: config.BASE_API_URL,
            headers: {
              'Content-Type': 'application/json',
            },
          }),
          apiKey: config.GMO_MP_TOKEN_API_KEY_MFJ,
          pubKey: config.GMO_MP_TOKEN_PUB_KEY_MFJ,
          productionMode: config.GMO_SHOP_OP_MODE,
        })
        console.log('mounted !!', mulpay)

        const elements = mulpay.createElements()

        const cardNumberInputElement = elements.create('cardNumber', {
          style: cardInputStyle,
          placeholder: 'Card Number',
        })
        const expiryInputElement = elements.create('cardExpiry', {
          style: expiryInputStyle,
        })
        const cvcInputElement = elements.create('cardCvc', {
          style: cvcInputStyle,
        })

        const cardNumberWrapperElement = document.getElementById('card-number')
        const cardExpiryWrapperElement = document.getElementById('expiry-month')
        const cardCvcWrapperElement = document.getElementById('security-code')

        cardNumberInputElement.mount(cardNumberWrapperElement)
        expiryInputElement.mount(cardExpiryWrapperElement)
        cvcInputElement.mount(cardCvcWrapperElement)

        this.setElements(
          cardNumberInputElement,
          expiryInputElement,
          cvcInputElement
        )
      },
      async setApplicationObj() {
        console.log('!!!setApplicationObj')
        const tmps =
          typeof this.application_obj === 'object' &&
          Object.keys(this.application_obj).length > 0
            ? this.application_obj
            : {
                id: 0,
                application_check_type: '',
                application_type: '',
                application_date: '',
              }
        this.application_obj = tmps

        this.communication_obj =
          this.application_obj &&
          this.application_obj.communications &&
          this.application_obj.communications[0]
            ? this.application_obj.communications[0]
            : {}
        this.communication_checked =
          this.application_obj && this.application_obj.checked
            ? this.application_obj.checked
            : []

        // pagemode
        console.log('setApplicationObj tmps', tmps)
        // 決済(application_check_type:400-423)
        if (
          (this.application_obj || {}).application_check_type == 400 &&
          parseInt((this.application_obj || {}).m_id) > 0
        ) {
          await this.mp_token_mount()
        } else if (
          (this.application_obj || {}).application_check_type == 200 &&
          parseInt((this.application_obj || {}).m_id) > 0
        ) {
          await this.mp_token_mount()
        }
        // 決済エラー
        else if (
          (this.application_obj || {}).application_check_type == 403 &&
          parseInt((this.application_obj || {}).m_id) > 0
        ) {
          // ここでもう一度appをチェックして、決済もチェックして問題ないか確認させる
          const sales =
            typeof (this.application_obj || {}).sales === 'object' &&
            Object.keys(this.application_obj.sales).length > 0
              ? { ...(this.application_obj || {}).sales }
              : false
          const sales_id = sales ? sales.id : 0
          const sparams = {}
          sparams['stat'] = [1]
          sparams['id'] = sales_id
          const success_check = await this.basicPosts_S(
            config.BASE_API_URL + '/sales/success_check',
            sparams
          )
            .then(async (response) => {
              console.log('success_check response', response)
              return response?.data?.body ? response.data.body : false
            })
            .catch(async (err) => {
              console.log(err)
              return false
            })
          console.log('403 check success_check', success_check)
          if (!success_check) {
            await this.update_app_check(400)
            this.page_mode = 'charge'
            this.message_class = 'danger'
          } else if (success_check) {
            const chkTYpe =
              sales.charge_type == 'CREDIT'
                ? 423
                : sales.charge_type == 'KONBINI'
                ? 426
                : 423
            await this.update_app_check(chkTYpe)
            return
          }
        }
        // 決済成功
        else if (
          ((this.application_obj || {}).application_check_type == 426 ||
            (this.application_obj || {}).application_check_type == 423) &&
          parseInt((this.application_obj || {}).m_id) > 0
        ) {
          const tmps = [...(this.application_obj || {}).draft_orders]
          this.draft_order_obj = [...tmps]

          await this.member_license_update()
          await this.update_app_check(430)
        }
        // 決済成功して戻ってくる
        else if (
          (this.application_obj || {}).application_check_type == 430 &&
          parseInt((this.application_obj || {}).m_id) > 0
        ) {
          await this.update_app_check(500)
        }

        // selected_variant取得
        if (
          (this.charge_mode || this.remand_mode) &&
          typeof (this.application_obj || {}).draft_orders === 'object'
        ) {
          // 一旦クリアする
          this.selected_variants = []
          this.draft_order_obj = [...this.application_obj.draft_orders]
          console.log('!!!draft_order_obj', this.draft_order_obj)
          await Promise.all(
            this.application_obj.draft_orders.map(async (order, idx) => {
              console.log(
                '!!!selected idx',
                idx,
                order.variant_id,
                order.sports_year_add
              )
              await this.sel_variant_year(
                order.variant_id,
                order.sports_year_add,
                true
              )
            })
          )
          console.log('!!!selected', this.selected_variants)
        }
      },

      updateChargeButtonState() {
        if (this.selected_charge_type !== 'creditcard') return

        const isFormComplete =
          this.cardValidation.cardNumber.complete &&
          this.cardValidation.expiry.complete &&
          this.cardValidation.cvc.complete

        const hasErrors =
          (this.cardValidation.cardNumber.error &&
            this.cardValidation.cardNumber.error.type !== 'validation_error') ||
          (this.cardValidation.expiry.error &&
            this.cardValidation.expiry.error.type !== 'validation_error') ||
          (this.cardValidation.cvc.error &&
            this.cardValidation.cvc.error.type !== 'validation_error')

        this.charge_btn_disabled = !(isFormComplete && !hasErrors)
      },

      async charge_credit() {
        try {
          /**
           * カード名義人を指定する場合（設定する場合は、注意が必要）
           * @see: https://static.mul-pay.jp/doc/card-token/#tag/elements/mulpay.getTokenThroughIframe(elementholdernameoptions)
           */
          this.setHolderName(this.holder_name)
        } catch (e) {
          alert(e.message)
          return
        }

        this.charge_btn_disabled = true
        this.isLoading = true

        try {
          await this.setCardPaymentPayload({
            payer: this.get_payer,
            merchant: this.get_merchant,
            order: this.get_order,
          })

          await this.cardPayment((payload) => {
            const { redirectInformation, orderReference } = payload

            if (!orderReference?.accessId) {
              alert(
                payload +
                  '\n3Dセキュア決済が失敗しました。カード情報をご確認下さい。'
              )
              return
            }

            localStorage.setItem('accessId', orderReference.accessId)
            localStorage.setItem(
              'formTokenId',
              (this.sales_data || {}).application_id
            )
            localStorage.setItem('formSalesId', (this.sales_data || {}).id)
            localStorage.setItem('sourceView', 'payment')
            localStorage.setItem('paymentComplete', '1')
            location.href = redirectInformation.redirectUrl
          }).catch(async (error) => {
            let error_json = error?.message
            if (this.is_json(error_json)) {
              const errorCode = []
              const parsedError = JSON.parse(error_json)
              if (parsedError) {
                for (const key in parsedError) {
                  if (
                    parsedError[key].legacyCode &&
                    !errorCode.includes(parsedError[key].legacyCode)
                  ) {
                    errorCode.push(parsedError[key].legacyCode)
                  }
                }
              }
              const error_msg =
                'カード決済エラーです。' +
                ((Array.isArray(errorCode) && errorCode.length > 0)
                  ? 'エラーコード:' + errorCode.join(',')
                  : '')
              alert(error_msg + 'カード情報を確認して下さい。')
            } else {
              alert('カード決済エラーです。カード情報を確認して下さい。')
            }
          })
        } catch (error) {
          console.error('決済処理全体エラー:', error)
          alert(
            `決済処理中にエラーが発生しました: ${
              error.message || 'システムエラー'
            }`
          )
        } finally {
          this.isLoading = false
          this.charge_btn_disabled = false
        }
      },
      async update_app_check(check_type) {
        console.log('update_app_check check_type', check_type)
        const post_url_path =
          this.sales_data.application_id > 0
            ? '/member_application/edit/' + this.sales_data.application_id
            : '/member_application/add'

        const params = {
          m_id: (this.data_obj || {}).id ? (this.data_obj || {}).id : 0,
          application_check_type: check_type,
        }
        await this.basicPosts_I(config.BASE_API_URL + post_url_path, params)
          .then(async (response) => {
            console.log('update_app_check', response)
          })
          .catch(async (err) => {
            console.log(err)
          })
          .finally(async () => {
            if (check_type != 403 && check_type != 500)
              await this.loadApplicationObj()
            this.charge_btn_disabled = false
            this.$forceUpdate()
          })
      },

      /**
       * コンビニ決済処理
       */
      async chargeCash({ name, nameKana, phoneNumber, code }) {
        this.charge_btn_disabled = true
        const payer_tmp = { ...this.get_payer }
        payer_tmp.name = name
        payer_tmp.nameKana = nameKana
        payer_tmp.phones = [
          {
            type: 'MOBILE',
            countryCode: '81',
            number: phoneNumber,
          },
        ]

        const payload = {
          payer: payer_tmp,
          merchant: this.get_merchant,
          order: this.get_order,
          cashOptions: {
            konbiniCode: code,
            paymentPeriod: '10',
          },
        }

        await this.setPaymentPayload(payload).catch(alert)
        try {
          await this.cashPayment(
            (this.application_obj || {}).member_regist_token || '',
            (this.sales_data || {}).application_id,
            (this.sales_data || {}).id,
            async (payload) => {
              if (!payload) {
                throw new Error('決済処理の結果が取得できませんでした。')
              }
              const { cashResult } = payload
              if (!cashResult) {
                throw new Error('決済情報が取得できませんでした。')
              }
              this.receipt = cashResult.konbiniPaymentInformation
              this.has_receipt_data = true
              const chk = await this.updateSalesReceipt(
                (this.sales_data || {}).id
              )
              if (chk) {
                await this.update_app_check(420)
              }
            }
          )
        } catch (error) {
          console.error('コンビニ決済エラー:', error)
          alert(error.message || 'コンビニ決済の処理中にエラーが発生しました。')
          await this.update_app_check(400)
        }
      },

      /**
       * 販売レシート情報を更新
       */
      async updateSalesReceipt(formSalesId) {
        const sales_url_path =
          formSalesId > 0 ? '/sales/konbini_set/' + formSalesId : false
        const sales_params = {
          sales_type: 'general',
          charge_type: 'KONBINI',
          cash_konbini_code: this.receipt?.konbiniCode,
          cash_receipt_number: this.receipt?.receiptNumber,
          cash_confirmation_number: this.receipt?.confirmationNumber,
        }
        return sales_url_path
          ? await this.basicPosts_I(
              config.BASE_API_URL + sales_url_path,
              sales_params
            )
          : false
      },

      async loadApplicationObj() {
        const params = {}
        params['stat'] = [1]
        params['m_id'] = this.$store.state.auth.userId
        params['application_type'] = 1500
        params['not_application_check_types'] = [500, 900]
        await this.basicPosts_S(
          config.BASE_API_URL + '/member_application/lists',
          params
        )
          .then(async (response) => {
            console.log('loadApplicationObj', response)
            // sales.id=77のデータをフィルタリング
            const filteredData =
              response.data?.body?.find(
                (item) =>
                  item.sales &&
                  item.sales.id === this.router.currentRoute.value.query.tkn
              ) || {}

            this.application_obj = filteredData
          })
          .catch(async (err) => {
            console.log(err)
            this.application_obj = {}
          })
          .finally(async () => {
            await this.setApplicationObj()
            await this.loadSalesData()
            this.$forceUpdate()
          })
      },

      async loadUserObj() {
        const params = {}
        params['stat'] = [1]
        params['id'] = this.$store.state.auth.userId
        await this.basicPosts_S(config.BASE_API_URL + '/member/lists', params)
          .then(async (response) => {
            console.log('loadUserObj', response)
            this.data_obj =
              response.data && response.data.body && response.data.body[0]
                ? response.data.body[0]
                : {}
            const member_license_tmp = this.data_obj?.member_license
              ? [...this.data_obj?.member_license]
              : []
            const member_license = member_license_tmp
            this.data_obj.member_license = member_license
          })
          .catch(async (err) => {
            console.log(err)
            this.data_obj = {}
          })
          .finally(async () => {
            await this.setUserObj()
            this.$forceUpdate()
          })
      },

      async setUserObj() {
        // have_licenseにいれるのはattach_have_licenseに集約
        this.form_obj = {
          name_1: (this.data_obj || {}).name_1,
          name_2: (this.data_obj || {}).name_2,
          yomi_1: (this.data_obj || {}).yomi_1,
          yomi_2: (this.data_obj || {}).yomi_2,
          birth_date: (this.data_obj || {}).birth_date,
          postal_cd: (this.data_obj || {}).postal_cd,
          pref_cd: (this.data_obj || {}).pref_cd,
          address_1: (this.data_obj || {}).address_1,
          address_2: (this.data_obj || {}).address_2,
          tel_1: (this.data_obj || {}).tel_1,
          tel_2: (this.data_obj || {}).tel_2,
          member_assets: (this.data_obj || {}).member_assets,
        }
        await this.attach_have_license()
      },
      async attach_have_license() {
        // 配列が存在するかチェック
        if (!this.member_license || !Array.isArray(this.member_license)) {
          this.member_license = [] // 配列が未定義なら初期化
        }

        if (this.selected_year?.length > 0) {
          const license_list =
            typeof (this.data_obj || {}).member_license === 'object'
              ? [...(this.data_obj || {}).member_license]
              : []
          const tmps = []
          this.selected_year.map((year_add) => {
            tmps.push(parseInt(this.get_term_year) + parseInt(year_add))
          })
          const lc_tmp = license_list
            .filter((license) => tmps.includes(parseInt(license.license_year)))
            .map((license) => {
              if (
                parseInt(license.license_year) > parseInt(this.get_term_year)
              ) {
                license.year_add = 1
              } else {
                license.year_add = 0
              }
              return license
            })
          this.have_license = [...lc_tmp]
        }
      },

      async loadMerchantObj(target_merchant) {
        await this.basicPosts_S(
          config.BASE_API_URL + '/merchant/' + target_merchant,
          {}
        )
          .then(async (response) => {
            console.log('loadMerchantObj', response)
            this.merchant_obj =
              response.data && response.data.body ? response.data.body : {}
            console.log('loadMerchantObj merchant_obj', this.merchant_obj)
          })
          .catch(async (err) => {
            console.log(err)
            this.merchant_obj = {}
          })
          .finally(async () => {
            this.$forceUpdate()
          })
      },
    },
    computed: {
      get_payer: function () {
        const payer_obj = {}
        payer_obj.name =
          (this.data_obj || {}).yomi_1 + (this.data_obj || {}).yomi_2
        payer_obj.nameKana =
          (this.data_obj || {}).yomi_1 + (this.data_obj || {}).yomi_2
        payer_obj.phoneNumber = (this.data_obj || {}).tel_1
        const phone_tmp = {
          number: (this.data_obj || {}).tel_1,
          countryCode: '81',
          type: 'MOBILE',
        }
        payer_obj.phones = [phone_tmp]
        return payer_obj
      },

      /**
       * マーチャント情報を取得
       */
      get_merchant() {
        const merchant_obj = { ...this.merchant_obj }
        merchant_obj.callbackUrl = config.GMO_CALLBACK_URL + '/request/3ds'
        merchant_obj.webhookUrl = config.GMO_WEBHOOK_URL
        return merchant_obj
      },

      /**
       * 注文情報を取得
       */
      get_order() {
        const order = {
          orderId: (this.sales_data || {}).charge_order_id,
          amount: (this.sales_data || {}).amount,
          currency: 'JPY',
          items: [],
        }

        if (
          typeof (this.sales_data || {}).sales_orders === 'object' &&
          (this.sales_data || {}).sales_orders.length > 0
        ) {
          order.items = this.sales_data.sales_orders.map((sales_order) => ({
            name: sales_order.sub_label,
            quantity: sales_order.num,
            type: 'DIGITAL',
            price: sales_order.list_price,
          }))
        }

        return order
      },
    },

    async created() {
      // 決済完了フラグをlocalStorageから確認
      if (localStorage.getItem('paymentComplete') === '1') {
        this.isPaymentComplete = true
        localStorage.removeItem('paymentComplete') // 一度だけ表示
      } else {
        this.isPaymentComplete = false
      }
      try {
        await this.loadMerchantObj('mfj')
        await this.setApplicationObj()
        await this.loadUserObj()
        await this.setUserObj()
        if (!this.isPaymentComplete) {
          await this.loadApplicationObj()
          await this.loadSalesData()
        }
      } catch (error) {
        console.error('初期化エラー:', error)
      }
    },

    beforeUnmount() {
      try {
        if (this.cardNumberElement) {
          this.cardNumberElement.unmount()
        }
        if (this.expiryElement) {
          this.expiryElement.unmount()
        }
        if (this.cvcElement) {
          this.cvcElement.unmount()
        }
        this.clear()
      } catch (error) {
        console.error('アンマウント時のエラー:', error)
      }
    },
  }
</script>

<style scoped>
  .card-form__div {
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
    padding: 0.375rem 0.75rem;
    margin-bottom: 1rem;
  }

  .loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
  }
</style>
